/* istanbul ignore file */
import * as yup from 'yup';
import { emailMsg, requiredMsg } from '../../utils/validationMessages';

export const EsgContactSchema = yup.object().shape({
  esgContact: yup.string().email(emailMsg('ESG contact')).required(requiredMsg('ESG contact')),
});
